<template>
  <div class="container">
    <div class="content" ref="table">
      <div class="tools clearfix">
        <div class="left">
          <el-input
            v-model="form.value"
            placeholder="搜索品牌名称"
            style="width: 210px; display: inline-block; margin-left: 10px"
          ></el-input>
          <el-button type="primary" style="margin-left: 16px" @click="getData"
            >搜索</el-button
          >
        </div>
        <div class="right">
          <el-button
            type="primary"
            style="margin-left: 16px"
            icon="el-icon-plus"
            @click="addBrand"
            v-hasPermi="['系统信息维护-车辆品牌维护', '新增']"
            >新增车辆品牌</el-button
          >
        </div>
      </div>
      <el-table
        stripe
        v-loading="loading"
        :data="table.data"
        height="calc(100% - 110px)"
        :header-cell-style="{ background: '#eaeef6' }"
        ref="tables"
      >
        <el-table-column type="index" label="序号" align="center">
        </el-table-column>
        <el-table-column prop="brand" label="名称" align="center">
        </el-table-column>
        <el-table-column prop="number" label="拥有车辆" align="center">
        </el-table-column>
        <el-table-column label="操作" width="170" align="center">
          <template slot-scope="scope">
            <div class="edit">
              <span
                class="btn read"
                @click="readClick(scope.row)"
                v-hasPermi="['系统信息维护-车辆品牌维护', '编辑']"
                >编辑</span
              >
              <span
                class="btn red"
                @click="delClick(scope.row.id)"
                v-hasPermi="['系统信息维护-车辆品牌维护', '删除']"
                >删除</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="sizes,prev, pager, next"
          :current-page.sync="table.currentPage"
          :page-size="table.size"
          :total="table.total"
          @current-change="currentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 新增/编辑 -->
    <edit v-if="dialogVisible" @refresh="getData" />
  </div>
</template>
<script>
import { GetDataBrand, deleteCarBrand } from '@/api/system'
import { MessageBox } from 'element-ui'
import edit from './edit'
export default {
  components: { edit },
  data () {
    return {
      dialogName: '',
      loading: false,
      dialogVisible: false,
      childform: {
        id: '',
        name: '',
      },
      form: {
        value: '',
        type: '',
      },
      options: [
        { label: '全部', value: 1 }
      ],
      table: {
        data: [
        ],
        height: 10,
        currentPage: 1,
        size: 50,
        total: 0
      }
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    delClick (id) {
      MessageBox.confirm('此操作将删除该品牌, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delBrande(id)
      }).catch(() => {
        this.$message('已取消删除')
      });
    },
    delBrande (id) {
      deleteCarBrand({ id }).then(res => {
        if (res.code === 0) {
          this.$message.success('删除成功!')
          this.getData()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    addBrand () {
      this.dialogName = '新增'
      this.dialogVisible = true
      this.childform.name = ''
    },
    getData () {
      this.loading = true
      const params = { start: this.table.currentPage, size: this.table.size, name: this.form.value }
      GetDataBrand(params).then(res => {
        this.loading = false
        this.table.data = res.data.content
        this.table.total = res.data.total
        this.$refs.tables.bodyWrapper.scrollTop = 0;
      })
    },
    currentChange () {
      this.getData()
    },
    handleSizeChange (e) {
      this.table.currentPage = 1
      this.table.size = e
      this.getData()
    },
    readClick (row) {
      this.childform.id = row.id
      this.dialogName = '编辑'
      this.dialogVisible = true
      this.childform.name = row.brand
    },

  },
  filters: {
    status_f (val) {
      let res = ''
      switch (val) {
        case 0:
          res = '离线'
          break;
        case 1:
          res = '在线'
          break;
      }
      return res
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  // padding: 20px 20px;
  .content {
    flex: 1;
    min-height: 0;
    .tools {
      padding-bottom: 20px;
      .left {
        float: left;
        input {
        }
      }
      .right {
        float: right;
      }
    }
    .edit {
      .btn {
        color: #3992de;
        cursor: pointer;

        & + .btn {
          margin-left: 24px;
        }
      }
      .red {
        color: #f00;
      }
    }
    .type {
      .iconfont {
        display: inline-block;
        width: 40px;
        text-align: center;
        color: #f00;
      }
    }
    .status {
      &.red {
        color: #f00;
      }
    }
    .pagination {
      text-align: center;
      padding-top: 20px;
    }
  }
}
</style>
<style lang="less">
.alarm-container {
  .el-table {
    .gutter {
      background: #eaeef6;
    }
  }
}
</style>

